// The guarantee badge with its drop shadow, exported from Figma at 1x and 2x (128×159 CSS px,
// including 16.5px of clear space above the badge). Served from this app's public folder.
const PDP_GUARANTEE_BADGE_PATH = '/images/pdp/guarantee-badge';
export const PDP_GUARANTEE_BADGE_URL = `${PDP_GUARANTEE_BADGE_PATH}@1x.png`;
export const PDP_GUARANTEE_BADGE_SRCSET = [
  { src: `${PDP_GUARANTEE_BADGE_PATH}@1x.png`, density: 1 },
  { src: `${PDP_GUARANTEE_BADGE_PATH}@2x.png`, density: 2 },
];
/** Browsers pick AVIF, then WebP, then the PNG fallback above. */
export const PDP_GUARANTEE_BADGE_SOURCES = [
  {
    type: 'image/avif',
    srcSet: [
      { src: `${PDP_GUARANTEE_BADGE_PATH}@1x.avif`, density: 1 },
      { src: `${PDP_GUARANTEE_BADGE_PATH}@2x.avif`, density: 2 },
    ],
  },
  {
    type: 'image/webp',
    srcSet: [
      { src: `${PDP_GUARANTEE_BADGE_PATH}@1x.webp`, density: 1 },
      { src: `${PDP_GUARANTEE_BADGE_PATH}@2x.webp`, density: 2 },
    ],
  },
];

export const PDP_HISTORY_DAY_CURRENT_URL =
  'https://images.opendoor.com/source/s3/imgdrop-production/2026-09-1790618004233-84999_pdp-history-day-current.svg?service=cosmos';
export const PDP_HISTORY_DAY_URL =
  'https://images.opendoor.com/source/s3/imgdrop-production/2026-09-1790618004234-67595_pdp-history-day.svg?service=cosmos';

export const PDP_SIMILAR_SHARE_URL =
  'https://images.opendoor.com/source/s3/imgdrop-production/2026-09-1790362473445-23288_pdp-similar-share.svg?service=cosmos';
export const PDP_SIMILAR_HEART_URL =
  'https://images.opendoor.com/source/s3/imgdrop-production/2026-09-1790362473446-03820_pdp-similar-heart.svg?service=cosmos';
export const PDP_SIMILAR_NEXT_URL =
  'https://images.opendoor.com/source/s3/imgdrop-production/2026-09-1790362473446-27927_pdp-similar-next.svg?service=cosmos';
export const PDP_SIMILAR_PREVIOUS_URL =
  'https://images.opendoor.com/source/s3/imgdrop-production/2026-09-1790362473446-41681_pdp-similar-previous.svg?service=cosmos';
